import { Button as MuiButton } from "@mui/material";
import { ReactNode } from "react";

interface IconButtonProps {
  icon: ReactNode;
  onClick?: (...args: any) => any;
  disabled?: boolean;
  className?: string;
}
export function IconButton({
  icon,
  onClick = undefined,
  disabled = false,
  className = "",
}: IconButtonProps) {
  return (
    <MuiButton onClick={onClick} disabled={disabled} className={className}>
      {icon}
    </MuiButton>
  );
}
